/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const signUpConfirmPostRequestSchema = z.object({
  client: z.string(),
  client_secret: z.string(),
  confirmation_code: z.string(),
  username: z.string(),
});
